var map = {
	"./add-circle-outline.vue": 12576,
	"./add-outline.vue": 61787,
	"./add-square-outline.vue": 95527,
	"./alert-circle-outline.vue": 89873,
	"./announcements-outline.vue": 66157,
	"./applications-fill.vue": 9913,
	"./applications-outline.vue": 30042,
	"./archive-add-outline.vue": 35714,
	"./archive-minus-outline.vue": 27756,
	"./arrow-down-outline.vue": 70726,
	"./arrow-left-1-outline.vue": 5877,
	"./arrow-left-2-outline.vue": 19887,
	"./arrow-right-1-outline.vue": 31374,
	"./arrow-right-2-outline.vue": 33557,
	"./arrow-up-outline.vue": 59078,
	"./backburger-outline.vue": 42062,
	"./bank-fill.vue": 69149,
	"./bank-outline.vue": 28317,
	"./book-fill.vue": 72695,
	"./book-outline.vue": 63937,
	"./bookmark-fill.vue": 88586,
	"./bookmark-outline.vue": 14845,
	"./box-fill.vue": 67669,
	"./box-outline.vue": 94519,
	"./calendar-outline.vue": 91110,
	"./call-outline.vue": 36318,
	"./cancel-outline.vue": 26688,
	"./chevron-down-outline.vue": 5180,
	"./chevron-left-outline.vue": 94798,
	"./chevron-right-outline.vue": 47434,
	"./chevron-up-outline.vue": 6308,
	"./circle-fill.vue": 87876,
	"./circle-outline.vue": 75762,
	"./clipboard-tick-fill.vue": 35627,
	"./clipboard-tick-outline.vue": 11654,
	"./clock-fill.vue": 89633,
	"./clock-outline.vue": 84985,
	"./close-circle-outline.vue": 50541,
	"./delete-outline.vue": 88612,
	"./disk-outline.vue": 95358,
	"./docs-outline.vue": 93542,
	"./document-copy-fill.vue": 2098,
	"./document-copy-outline.vue": 66460,
	"./document-download-outline.vue": 52992,
	"./document-edit-outline.vue": 17370,
	"./document-text-fill.vue": 13517,
	"./document-text-outline.vue": 96853,
	"./document-upload-outline.vue": 68278,
	"./documentation-outline.vue": 84614,
	"./double-chevron-left-outline.vue": 48553,
	"./double-chevron-right-outline.vue": 14243,
	"./download-outline.vue": 43566,
	"./element-fill.vue": 60014,
	"./element-outline.vue": 375,
	"./email-outline.vue": 2863,
	"./export-fill.vue": 18445,
	"./export-outline.vue": 27556,
	"./eye-off-outline.vue": 76817,
	"./eye-outline.vue": 18650,
	"./filter-fill.vue": 54801,
	"./filter-outline.vue": 97585,
	"./folder-add-outline.vue": 18690,
	"./folder-cross-outline.vue": 99906,
	"./folder-edit-outline.vue": 62552,
	"./folder-open-outline.vue": 22226,
	"./folder-outline.vue": 61852,
	"./forwardburger-outline.vue": 92631,
	"./global-fill.vue": 69497,
	"./global-outline.vue": 77788,
	"./hierarchy-fill.vue": 4362,
	"./hierarchy-outline.vue": 99286,
	"./home-fill.vue": 47304,
	"./home-outline.vue": 57912,
	"./hospital-outline.vue": 68869,
	"./house-fill.vue": 51208,
	"./house-outline.vue": 13507,
	"./houses-outline.vue": 57478,
	"./iconsax-menu-outline.vue": 34968,
	"./import-outline.vue": 2781,
	"./info-circle-outline.vue": 72581,
	"./info-hub-outline.vue": 76141,
	"./list-fill.vue": 98110,
	"./list-outline.vue": 7008,
	"./location-outline.vue": 58829,
	"./logout-outline.vue": 32603,
	"./mail-outline.vue": 59514,
	"./maximize-outline.vue": 94136,
	"./menu-down-outline.vue": 36269,
	"./menu-outline.vue": 27360,
	"./menu-up-outline.vue": 34816,
	"./message-question-fill.vue": 92201,
	"./message-question-outline.vue": 28660,
	"./messages-fill.vue": 53108,
	"./messages-outline.vue": 19608,
	"./minimize-outline.vue": 1223,
	"./minus-outline.vue": 40089,
	"./more-circle-outline.vue": 99752,
	"./more-outline.vue": 42631,
	"./more-vertical-outline.vue": 5085,
	"./move-outline.vue": 90605,
	"./note-fill.vue": 30926,
	"./note-outline.vue": 69368,
	"./notification-outline.vue": 77603,
	"./phone-outline.vue": 90804,
	"./placeholder-fill.vue": 53517,
	"./placeholder-outline.vue": 94533,
	"./plus-outline.vue": 52311,
	"./profile-user-fill.vue": 93262,
	"./profile-user-outline.vue": 15056,
	"./selectable-outline.vue": 32115,
	"./selected-outline.vue": 51656,
	"./setting-4-fill.vue": 42382,
	"./setting-4-outline.vue": 77263,
	"./setting-fill.vue": 99420,
	"./setting-outline.vue": 83452,
	"./share-outline.vue": 88181,
	"./sort-outline.vue": 81979,
	"./table-outline.vue": 18998,
	"./tag-right-outline.vue": 11866,
	"./task-square-fill.vue": 37481,
	"./task-square-outline.vue": 71959,
	"./teacher-fill.vue": 90424,
	"./teacher-outline.vue": 47233,
	"./tick-circle-fill.vue": 68808,
	"./tick-circle-outline.vue": 49973,
	"./tick-outline.vue": 46865,
	"./ticket-fill.vue": 65743,
	"./ticket-outline.vue": 23346,
	"./ticket-star-fill.vue": 63931,
	"./ticket-star-outline.vue": 1530,
	"./trash-outline.vue": 58969,
	"./user-add-fill.vue": 2834,
	"./user-add-outline.vue": 73428,
	"./user-fill.vue": 50864,
	"./user-minus-fill.vue": 97517,
	"./user-minus-outline.vue": 17594,
	"./user-octagon-fill.vue": 73385,
	"./user-octagon-outline.vue": 93337,
	"./user-outline.vue": 33701,
	"./user-tick-fill.vue": 78588,
	"./user-tick-outline.vue": 38373,
	"./video-octagon-fill.vue": 97346,
	"./video-octagon-outline.vue": 91918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53671;